import { setLocaleField } from "web/Layout/Translations/LanguageWrapper";

import { IUrlMenuItem } from "web/types/Menu";

interface IHandleUrlArgs {
  menuItem: IUrlMenuItem;
  currentLanguage: string;
}

const handleUrl = ({ menuItem, currentLanguage }: IHandleUrlArgs) => ({
  ...menuItem,
  url: setLocaleField(currentLanguage, menuItem.url, menuItem.url_en),
});

export default handleUrl;
